// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__U2AO8","title":"Info_title__2y3bM","links":"Info_links__1OH-h","link":"Info_link__7t7iN","logo":"Info_logo__1jzdT"};